// extracted by mini-css-extract-plugin
module.exports = {"outer":"Dialog_outer__HAg_n","inner":"Dialog_inner__MOcLx"};